<template>
  <TimeRangePanel ref="timeRangePanelRef" @pick="handlePick" />
</template>

<script>
import TimeRangePanel from "./TimeRangePanel.vue";
/**
 * 日期区间选择组件
 * 进出都是{Date}类型
 */
export default {
  name: "SmartTimeRangePanel",
  emits: ["input"],
  components: {
    TimeRangePanel,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    val: {
      get() {
        return [
          this.$refs.timeRangePanelRef?.minDate,
          this.$refs.timeRangePanelRef?.maxDate,
        ];
      },
      //进
      set(val) {
        if (this.$refs.timeRangePanelRef) {
          const [start, end] = val;
          this.$refs.timeRangePanelRef.value = [start, end];
        }
      },
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.val = newVal;
      },
    },
  },
  methods: {
    handlePick([start, end]) {
      //出
      this.$emit("input", [start, end]);
    },
  },
};
</script>
